import { Box, TextField, Button } from "@mui/material";
import { hr } from "@/constants/strings.hr";

type CommentComposerProps = {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  submitting: boolean;
};

export function CommentComposer({
  value,
  onChange,
  onSubmit,
  submitting,
}: CommentComposerProps) {
  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        multiline
        rows={3}
        placeholder={hr.comments.placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{ mb: 1 }}
      />
      <Button
        variant="contained"
        size="small"
        onClick={onSubmit}
        disabled={submitting || !value.trim()}
      >
        {hr.comments.submit}
      </Button>
    </Box>
  );
}
